import { create } from "zustand";

export const useBreadcrumbStore = create((set) => ({
    items: [],
    setBreadcrumb: (items) => {
        //console.log("setBreadcrumb called with:", items);
        set({ items });
    },
}));